import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { take } from 'rxjs/operators'
import { SharedModule } from '@tv3/shared/shared.module'
import { ComponentType } from '@angular/cdk/portal'
import { HomeAwayRentalConfigView } from '@tokeet-frontend/channels'
import { HomeAwayConnectionOverlayComponent } from '@tv3/containers/channels/connection-detail/feed/homeaway-connection-overlay/homeaway-connection-overlay.component'
import { ConnectionView } from '@tv3/store/connection/connection.view'
import { HvmiConnectionOverlayComponent } from '@tv3/containers/channels/connection-detail/feed/hvmi-connection-overlay/hvmi-connection-overlay.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable({
  providedIn: SharedModule,
})
export class HvmiConnectionOverlayService {
  constructor(private dialog: DialogService) {}

  public open<T>(connection: ConnectionView, component: ComponentType<T>): MatDialogRef<T> {
    const defaultConfig: MatDialogConfig = {
      data: { connection },
      panelClass: ['drawer-full-80'],
    }

    const dialogRef = this.dialog.openDrawer(component, defaultConfig)

    return dialogRef
  }

  public openSide(connection: ConnectionView) {
    return this.open(connection, HvmiConnectionOverlayComponent)
  }
}
